import React, { useEffect } from "react";
import {
    Container,
    Row,
    Col,
    CardBody,
    CardTitle,
    CardText,
    ListGroup,
    ListGroupItem,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import VisimisiPageHeader from "../../components/Headers/VisimisiPageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";
import "@fortawesome/fontawesome-free/css/all.min.css";

const VisimisiPage = () => {
    useEffect(() => {
        // Initialize AOS
        AOS.init({
            duration: 1000, // Animation duration
            once: true, // Animation happens only once
        });

        // Adding classes to body for layout consistency
        document.body.classList.add("profile-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);

        return () => {
            // Cleanup the classes when the component is unmounted
            document.body.classList.remove("profile-page", "sidebar-collapse");
        };
    }, []);

    return (
        <>
            {/* Navbar */}
            <ExamplesNavbar />

            <div className="wrapper">
                {/* Header */}
                <VisimisiPageHeader />

                <section className="visi">
                    <Container className="mt-5">
                        <Row>
                            <Col data-aos="fade-up" data-aos-delay="200">
                                <CardBody>
                                    {/* Visi Section */}
                                    <h4>
                                        <i className="fas fa-thumb-tack"></i> Visi
                                    </h4>
                                    <CardText>
                                        Menjadi Yayasan yang Terbaik di Tingkat Nasional dalam
                                        Memberikan Nilai Tambah & Layanan bagi seluruh
                                        Stakeholder-nya.
                                    </CardText>

                                    {/* Misi Section */}
                                    <h4>
                                        <i className="fa fa-star"></i> Misi
                                    </h4>
                                    <ListGroup>
                                        <ListGroupItem
                                            data-aos="fade-left"
                                            data-aos-delay="300"
                                            style={{
                                                border: "none",
                                                background: "none",
                                                padding: "10px 0",
                                            }}
                                        >
                                            <i
                                                className="fa fa-circle"
                                                aria-hidden="true"
                                                style={{ fontSize: "8px", marginRight: "5px" }}
                                            ></i>
                                            Menciptakan Sumber Daya Manusia yang Berkualitas,
                                            Berdaya Saing Tinggi, Profesional, dan Berkarakter
                                            Mandiri.
                                        </ListGroupItem>
                                        <ListGroupItem
                                            data-aos="fade-left"
                                            data-aos-delay="400"
                                            style={{
                                                border: "none",
                                                background: "none",
                                                padding: "10px 0",
                                            }}
                                        >
                                            <i
                                                className="fa fa-circle"
                                                aria-hidden="true"
                                                style={{ fontSize: "8px", marginRight: "5px" }}
                                            ></i>
                                            Menciptakan Jaringan yang Luas dengan Industri Di dalam
                                            dan Diluar Negeri.
                                        </ListGroupItem>
                                        <ListGroupItem
                                            data-aos="fade-left"
                                            data-aos-delay="500"
                                            style={{
                                                border: "none",
                                                background: "none",
                                                padding: "10px 0",
                                            }}
                                        >
                                            <i
                                                className="fa fa-circle"
                                                aria-hidden="true"
                                                style={{ fontSize: "8px", marginRight: "5px" }}
                                            ></i>
                                            Mengelola Yayasan secara Bersih, Bertanggung Jawab dan
                                            Menomorsatukan Integritas.
                                        </ListGroupItem>
                                        <ListGroupItem
                                            data-aos="fade-left"
                                            data-aos-delay="600"
                                            style={{
                                                border: "none",
                                                background: "none",
                                                padding: "10px 0",
                                            }}
                                        >
                                            <i
                                                className="fa fa-circle"
                                                aria-hidden="true"
                                                style={{ fontSize: "8px", marginRight: "5px" }}
                                            ></i>
                                            Menyediakan Layanan Kesehatan yang Berkualitas &
                                            Terjangkau.
                                        </ListGroupItem>
                                    </ListGroup>
                                </CardBody>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Footer */}
                <DefaultFooter />
            </div>
        </>
    );
};

export default VisimisiPage;
